// extracted by mini-css-extract-plugin
export var dividerLine = "_4r-0";
export var errorBackground = "_4r-1";